export default "__VITE_ASSET__DiLMEGrW__"